import { adsManagerUrl } from "@nabla/api";
import { entrypoint, viewOf } from "../../client/index.ts";
import { scopeExploration, scopeView } from "../overview/entrypoint.ts";

const conta = viewOf("conta");

export const entrypoints = [entrypoint({
  id: "conta",
  path: "/conta/:act",
  level: "conta",
  replaceOn: scopeExploration,
  data: ({ act }, query) => conta({ act }, { dias: query.get("dias") ?? undefined }),
  view: scopeView(() => import("./view.tsx")),
  place: (data) => ({
    title: data.scope.name,
    self: data.scope,
    path: data.path,
    ...(data.siblings ? { siblings: data.siblings } : {}),
    managerUrl: data.scope.place === "conta" ? adsManagerUrl({ place: "conta", account: data.scope.id }) : null,
  }),
  morph: ({ act }) => `obj-${act}`,
})];
